import { render, staticRenderFns } from "./MyTag.vue?vue&type=template&id=6ebf9366"
import script from "./MyTag.vue?vue&type=script&lang=js"
export * from "./MyTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports